<script setup>

    import { ArrowLongRightIcon } from '@heroicons/vue/20/solid'

</script>

<template>

    <div class="sm:col-span-1 pt-4 pb-8 md:py-0 md:col-span-7 md:pr-12">

        <h3 class="font-bold mb-2 text-lifeworx-blue-700">
            {{ 'Client' }}
            <ArrowLongRightIcon class="-mt-0.5 inline-flex h-5 w-5" aria-hidden="true" />
            {{ 'Caregiver Feedback' }}
        </h3>

        <p class="text-md md:text-sm tracking-wide">
            Collecting feedback from clients is crucial in ensuring that our caregivers are meeting their needs effectively, identifying areas of improvement, and maintaining the highest level of quality service.
        </p>

    </div>

</template>
